import React, { Component } from "react";
import Cookies from "universal-cookie";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
//import ShareButtonsPasakumi from "../components/sharebuttons_pasakumi";
//import { Link } from "react-router-dom";
//import Truncate from 'react-truncate-html';
import Moment from "react-moment";
import 'moment-timezone';
import moment from 'moment';
import "jquery";
import "bootstrap";
import Slider from "react-slick";

import { library } from "@fortawesome/fontawesome-svg-core";
// import the Facebook and Twitter icons
import {
  faChevronLeft,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";

import {
  faTwitterSquare,
  faFacebookSquare
} from "@fortawesome/free-brands-svg-icons";


const cookies = new Cookies();
//console.log(cookies.get("lang"));

library.add(faChevronLeft, faChevronRight, faTwitterSquare, faFacebookSquare);

const QUERY = gql`
  query Pasakumi($lang: LanguageCodeFilterEnum) {
    pasakumi(where: { language: $lang }) {
    edges {
      node {
        translations {
          content(format: RENDERED)
        }
        pasakumuKategorijas {
          edges {
            node {
              id
              name
              translation(language: EN) {
                slug
                name
              }
              slug
              krasa {
                krasa
              }
            }
          }
        }
        pasakuma_info {
          apraksts
          datumsLaiks
          eventUrl
          atteli {
            sourceUrl
          }
        }
        slug
        title(format: RENDERED)
      }
    }
  }
    themeGeneralSettings {
      optionsPage {
        singlePostShareButtonsText
        singlePostShareButtonsTextEn
        gimmeMore
        gimmeMoreEn
        readMore
        readMoreEn
      }
    }
  }
`;

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <i
        className="fas fa-chevron-right"
        data-fa-transform="grow-12 left-26"
      ></i>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <i
        className="fas fa-chevron-left"
        data-fa-transform="grow-12 right-26"
      ></i>
    </div>
  );
}

class MatchList extends Component {
  render() {
    const {
      data: { loading, errors, pasakumi }
    } = this.props;

    //console.log(this.state.cardData);
    //console.log(this.state.merged);
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      lazyLoad: true,
      swipeToSlide: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    };
    
    !loading &&
        pasakumi &&
        pasakumi.edges.sort(function (a, b) {
          //var datestamp = moment(a.node.pasakuma_info.datumsLaiks).format('X');
          return moment(a.node.pasakuma_info.datumsLaiks).format('x').localeCompare(moment(b.node.pasakuma_info.datumsLaiks).format('x'));
        });

    return (
      <div id="programma"
        data-headertitle={
          cookies.get("lang") === "LV" ? "Programma" : cookies.get("lang") === "EN" ? "Programme" : null
        } className="container prog-slider">
        {loading && <div className="loader" />}
        {errors && <div className="errors">...</div>}

        {!loading && !pasakumi && <span className="none">Nav pasākumu...</span>}

        <Slider className="carousel-inner w-100 mx-auto"  {...settings}>

          {!loading &&
            pasakumi &&
            pasakumi.edges.filter(match => moment(match.node.pasakuma_info.datumsLaiks) >= moment()).map((match, i) => (
              <div key={i}>
                <div
                  className="carousel-item-prog"
                >
                  <div className={`prog_top_date ${match.node.pasakumuKategorijas.edges[0] ? "cat_" + match.node.pasakumuKategorijas.edges[0].node.slug : "default-color"}`}>
                    {(() => {
                      var cardStartWMonth =
                        moment(match.node.pasakuma_info.datumsLaiks).format('DD.MM.');
                      //console.log(match.node.pasakuma_info.datumsLaiks);

                      return cardStartWMonth




                    })()}
                  </div>
                  <div className={`carousel-wrap ${match.node.pasakumuKategorijas.edges[0] ? "cat_" + match.node.pasakumuKategorijas.edges[0].node.slug : "default-color"}`}>
                    <a href={`/${cookies.get("lang").toLowerCase()}/event/${match.node.slug}`} >
                      {match.node.pasakuma_info.atteli[0].sourceUrl ? (
                        <div className="prog_img_wrap">
                          <div
                            className="prog_img"
                            style={{
                              //backgroundImage: `url(${card.attachData.url})`
                              backgroundImage: `url(${match.node.pasakuma_info.atteli[0].sourceUrl})`
                            }}
                          ></div>
                        </div>
                      ) : null}
                      <div className="prog_info_wrap">
                        <div className="prog_descr">
                          <span className="cardTitle">{match.node.title}</span>
                          <span className="newtime">
                            {(() => {
                              if (!isNaN(match.node.pasakuma_info.datumsLaiks)) {
                                return "?";
                              } else {
                                return <Moment format="HH:mm">{match.node.pasakuma_info.datumsLaiks}</Moment>;
                              }
                            })()}
                          </span>

                        </div>

                      </div>
                    </a>
                  </div>
                </div>
              </div>
            ))}

        </Slider>



      </div>
    );
  };
}

const cookieLang = cookies.get("lang");

export default graphql(QUERY, {
  options: {
    variables: {
      lang: cookieLang
    }
  }
})(MatchList);
